import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../../environments/environment';

export interface CSVResponse {
  csv_string: string;
}

@Injectable({
  providedIn: 'root',
})
export class ProspectiveUserService {
  apiUrl = environment.apiUrl + '/prospective_users/';

  constructor(readonly http: HttpClient) {}

  getProspectiveUsersCSV(): Observable<string> {
    return this.http.get<CSVResponse>(`${this.apiUrl}csv`).pipe(
      map((response: CSVResponse) => {
        return response.csv_string;
      })
    );
  }
}
